import React from 'react';
import _ from 'lodash';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { CleryBioProfessionalItem } from '../model/clergy-bio-app-models';
import { deleteAction } from './models/form-models';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { FormGroup } from '../../../global/components/layout/form-group';


interface Props {
	settings: ClergyBioSettings;
	id: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	professionalItem: CleryBioProfessionalItem;
	defaultValue: CleryBioProfessionalItem;
	setList?: any;
}

function ClergyBioPublicationItem(props: Props) {

	const buttonClasses = buttonStyles();
	const { settings, arrayField, id, formikProps, setList, professionalItem, defaultValue } = props;


	const remove = () => {
		const list = _.cloneDeep(formikProps?.values[arrayField]);
		const toDelete = { ...defaultValue };
		toDelete.action = deleteAction;
		list[id] = toDelete;
		const copy = { ...formikProps?.values };
		copy[arrayField] = list;
		setList(copy);
	};

	if (professionalItem?.action === deleteAction) {
		return null;
	}

	return (
		<ContentSpacer>
			<FormGroup>
				<FormField
					name={`${arrayField}.${id}.role`}
					label={settings?.roleLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
					required
				/>

				<FormField
					name={`${arrayField}.${id}.title`}
					label={settings?.titleOfWorkLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
					required
				/>

				<FormField
					name={`${arrayField}.${id}.publication`}
					label={settings?.nameOfPublicationLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
				/>

				<FormField
					name={`${arrayField}.${id}.publisher`}
					label={settings?.publisherLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
				/>

				<FormField
					name={`${arrayField}.${id}.year`}
					label={settings?.yearLabel}
					component='input'
					touched={formikProps.touched}
					errors={formikProps.errors}
				/>

				<div className='form-item'><button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >{settings?.removeChildButtonText}</button></div>

			</FormGroup>
		</ContentSpacer>
	);
}

ClergyBioPublicationItem.defaultProps = {
	setList: null,
};
export default ClergyBioPublicationItem;